import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExclamRound = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 17 17",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 8.5,
		cy: 8.5,
		r: 8.5,
		fill: "#FA4F38"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M7.792 10.584H8.968L9.626 4.144V3.808H7.134V4.144L7.792 10.584ZM7.246 14H9.514V11.732H7.246V14Z",
		fill: "white"
	})]
});
export default SvgExclamRound;
